import { createSelector } from 'reselect';
import dollars from '../utils/dollars';

const getDiscountAmountInCents = ({ payment }) => payment.discountAmountInCents;
const getDiscountPercentage = ({ payment }) => payment.discountPercentage;
const getTotalPrice = state => {
  let total = state.selectedDevices.prices.total || 0;

  return state.selectedDevices.archive.reduce(
    (acc, d) => acc + d.prices.total,
    total
  );
};

export const getDiscountDetails = createSelector(
  [getDiscountAmountInCents, getDiscountPercentage, getTotalPrice],
  (discountAmountInCents, discountPercentage, totalPrice) => {
    let value = 0;
    let label = '';

    if (discountAmountInCents) {
      label = `${dollars(discountAmountInCents / 100)} Discount`;
      value = discountAmountInCents;
    } else if (discountPercentage) {
      label = `${discountPercentage * 100}% Discount`;
      value = totalPrice * discountPercentage;
    }

    return { label, value };
  }
);

export const calculatePriceAfterDiscount = createSelector(
  [getDiscountDetails, getTotalPrice],
  ({ value: discountValue }, totalPrice) => totalPrice - discountValue
);

export const determineDiscountExistence = createSelector(
  [getDiscountAmountInCents, getDiscountPercentage],
  (discountAmountInCents, discountPercentage) =>
    Boolean(discountAmountInCents) || Boolean(discountPercentage)
);
